import { WorkOrder } from "@/services/backend/rlt/work-orders/types/work-order";
import { useState } from "react";
import {
  UpdateEndDateRequest,
  useRltWorkOrderUpdateEndDateMutation,
} from "@/services/backend/rlt/work-orders/api/work-order-api";
import { useDebouncedMutation } from "@/shared/lib/debounce/debounce";
import {
  errorsFor,
  useErrDocumentNotReady,
} from "@/shared/bsm/core/document/components/ui/err-document-not-ready";
import { fieldErrors } from "@/shared/lib/errors/validation-error";
import t from "@/lang/lang";
import { DateTimeInput } from "@/shared/components/form/datetime-input";

export function WorkOrderEndDateInput({
  workOrder,
  disabled = false,
}: {
  workOrder: WorkOrder;
  disabled?: boolean;
}) {
  const [request, setRequest] = useState<UpdateEndDateRequest>({
    id: workOrder.id,
    endDate: workOrder.endDate,
  });
  const mutation = useRltWorkOrderUpdateEndDateMutation();
  const { error } = useDebouncedMutation(request, setRequest, mutation, {
    id: workOrder.id,
    endDate: workOrder.endDate,
  });

  const { notReadyError, resetNotReadyErrorField } = useErrDocumentNotReady();

  const errors = [
    ...(errorsFor(notReadyError, "endDate") ?? []),
    ...(fieldErrors(error, "endDate") ?? []),
  ];

  return (
    <DateTimeInput
      label={t("Ende der Arbeiten")}
      date={request.endDate}
      onDateChange={(endDate) => {
        setRequest({ ...request, endDate: endDate ?? "" });
        resetNotReadyErrorField("endDate");
      }}
      errors={errors}
      disabled={disabled}
    />
  );
}
